import { render, staticRenderFns } from "./MySnackbar.vue?vue&type=template&id=3c0d6320"
import script from "./MySnackbar.vue?vue&type=script&lang=js"
export * from "./MySnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports